import { useEffect, useRef } from 'react'
import { checkExpiryFiles, getUserSettings } from '../api'
import { USER_SETTINGS } from '../constant'
import { initComments } from '../slice/commentSlice'
import { initializeReferencesThunk } from '../slice/referenceSlice'
import { removeFileFromDB, revalidateFiles } from '../utils/db'
import { removeLocalFileRecordWithIds } from '../workbook'
import { useAppDispatch } from '../dispatch'
import { MainLayoutStateAction } from '../context/LayoutContext'
import { errorFormatter } from '../utils/error'

const useInit = (
  dispatch: ReturnType<typeof useAppDispatch>,
  storeDispatch: React.Dispatch<MainLayoutStateAction>
) => {
  const dispatchRef = useRef(dispatch)
  const storeDispatchRef = useRef(storeDispatch)

  useEffect(() => {
    const func = async () => {
      /** await functions to avoid office general exception */
      await dispatchRef.current(initializeReferencesThunk())
      // await dispatchRef.current(initActiveWorksheet())
      // await dispatchRef.current(initSaveToLocal())
      await dispatchRef.current(initComments())
      //   await dispatch(initUserEmail())
      const fileIds = await checkExpiryFiles()
      await removeLocalFileRecordWithIds(fileIds)
      const mapped = fileIds.map((id) => removeFileFromDB(id))
      await Promise.all(mapped)
      await revalidateFiles(7)
      const userSettings = await getUserSettings()
      if (userSettings.status === 200) {
        localStorage.setItem(
          USER_SETTINGS,
          JSON.stringify(userSettings.data.data)
        )
      }
    }

    func()
      .then(() => {
        storeDispatchRef.current({
          type: 'SET_READY',
        })
      })
      .catch((err) => {
        console.error(`Application initialization error: err=${err}`)
        storeDispatchRef.current({
          type: 'SET_ERROR',
          payload: errorFormatter(err),
        })
      })
  }, [])
}

export default useInit
